// React for Website

import React, { useState } from "react";
//outsource
import { Col, Input, Form, Button, Popover } from "antd";
import { CopyOutlined } from "@ant-design/icons";
//components

const VoucherLink = ({ href, disabled }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION ------------------------
  const handleCopy = () => {
    navigator.clipboard.writeText(href);
  };

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Form.Item label="Purchase link">
      <Input
        placeholder="Please fill marketing code"
        addonAfter={
          <Popover content={"Copied !"} trigger="click">
            <Button
              onClick={handleCopy}
              size="small"
              type="text"
              icon={<CopyOutlined />}
            />
          </Popover>
        }
        value={href}
        disabled={true}
      />
    </Form.Item>
  );
};

export default VoucherLink;
